import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 기업 성장 로드맵(specs/071) — 기업 셀프 묶음(COMPANY_HOME) + 로드맵 기능(ROADMAP, 화면이 확인)을 함께 요구한다. */
export const myRoadmapRoutes: RouteObject[] = [
  {
    path: 'my-roadmap',
    lazy: page('MyRoadmapPage'),
    handle: {
      title: '성장 로드맵',
      yearIndependent: true,
      feature: 'COMPANY_HOME',
    } satisfies RouteHandle,
  },
];
